export const userPrivillegeReducerSelector = state => state.userPrivillegeReducer;
